var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutward01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.87,14.21a.41.41,0,0,1-.32.46c-1.69.62-3.36,1.26-5.05,1.9l-.25.08V12.43l.3-.11,5.31-2C14.87,11.63,14.85,12.92,14.87,14.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.09,7.55,17.36,8.8l-8.11,3c0-.71,0-1.41,0-2.12a.34.34,0,0,1,.26-.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.91,7.69,9.36,5.18l.06,0,2.06-.7a.58.58,0,0,1,.32,0L17.85,6.7l.11.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,12.3l.66.26v4a.58.58,0,0,1,0,.1.39.39,0,0,1-.15,0L3.59,14.93c-.18-.06-.28-.14-.31-.28a.43.43,0,0,1,0-.2V14c0-1.2,0-2.41,0-3.61Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.79,7.62,0,6.85l.77-.31c1.69-.68,3.38-1.37,5.08-2a.75.75,0,0,1,.49,0l2.12.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.62,9.64v2.3L.41,8.67,3.89,7.41l4.5,1.92C8.54,9.39,8.62,9.45,8.62,9.64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.44,2.88c0,.36,0,.65,0,1,0,.76,0,1.52,0,2.28,0,.46.23.71.58.69s.54-.27.53-.74c0-.86,0-1.73-.05-2.59V3.06l.74.58c.11.08.21.17.32.24a.56.56,0,0,0,.75-.1.54.54,0,0,0,0-.75c-.67-.55-1.36-1.1-2.07-1.61a.63.63,0,0,0-.58,0c-.71.43-1.41.89-2.11,1.36a.55.55,0,0,0-.17.79.55.55,0,0,0,.78.14C7.56,3.46,8,3.19,8.44,2.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutward01);
export default __webpack_public_path__ + "static/media/outward-01.602813d1.svg";
export { ForwardRef as ReactComponent };